export const gridLayouts: [string, string, string][] = [
  [
    '"camera camera camera room room"',
    '"camera camera camera day limit"',
    '"units units units units units"'
  ],
  [
    '"room room camera camera camera"',
    '"day limit camera camera camera"',
    '"units units units units units"'
  ],
  [
    '"units camera camera room room"',
    '"units camera camera room room"',
    '"units camera camera day limit"'
  ],
  [
    '"units camera camera camera room"',
    '"units camera camera camera day"',
    '"units camera camera camera limit"'
  ],
  [
    '"units units units units units"',
    '"camera camera camera room room"',
    '"camera camera camera day limit"'
  ],
  [
    '"units units units units units"',
    '"room room camera camera camera"',
    '"day limit camera camera camera"'
  ],
  [
    '"units units units units units"',
    '"room room camera camera camera"',
    '"day limit camera camera camera"'
  ],
  [
    '"units units units units units"',
    '"room room camera camera camera"',
    '"day limit camera camera camera"'
  ]
];
